import {Component, forwardRef, Injector, ViewChild} from '@angular/core';
import {SectionSelector} from '@twpub/core/models/wrappers/section-selector';
import {ComponentCategory, SessionParam} from '@twpub/core/enums';
import {SectionSelectorDirective} from './section-selector.directive';
import {Section, SelectItem} from '@twpub/core/models';
import {DictionaryService} from '@twpub/core/services';
import {BaseWrapperComponent} from '@twpub/shared/components/base';

@Component({
  selector: 'pub-section-wrapper',
  template: '<ng-template pubSectionSelect></ng-template>',
  standalone: true,
  imports: [SectionSelectorDirective]
})
export class SectionWrapperComponent extends BaseWrapperComponent<SectionSelector> {
  override compCategory = ComponentCategory.SectionSelector;
  override changesTriggers: SessionParam[] = [SessionParam.DICT_IDS];
  sections: Section[] = [];
  @ViewChild(forwardRef(() => SectionSelectorDirective), {static: true}) pubSectionSelect!: SectionSelectorDirective

  constructor(injector: Injector, private dictService: DictionaryService) {
    super(injector)
  }

  protected override handleSessionChanges() {
    this.fetchSections();
  }

  private fetchSections() {
    const dictIds = this.sharedStateService.getDictionaryIds();
    this.dictService.getSections(dictIds).subscribe((sections) => {
      this.sections = sections;
      this.update();
    });
  }

  getViewContainerRef() {
    return this.pubSectionSelect.viewContainerRef;
  }

  override createComponent(): SectionSelector {
    const comp = super.createComponent();
    comp.selectValues.subscribe((event: string[]) => this.sharedStateService.selectSections(event))
    this.fetchSections()
    return comp;
  }

  override update() {
    super.update((comp) => {
      comp.selectedValues = this.sharedStateService.getSectionOids();
      comp.items = this.sections.map((section) => new SelectItem(section.oid, section.name));
    })
  }
}
